// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const ShoppingCart = (props) => (
    <SvgIcon width="24px" height="20px" viewBox="0 0 24 20" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-1344.000000, -920.000000)">
                <g transform="translate(981.000000, 61.000000)">
                    <g transform="translate(17.000000, 859.000000)">
                        <g transform="translate(346.000000, 0.000000)">
                            <rect x="0" y="0" width="24" height="24"></rect>
                            <g
                                transform="translate(1.000000, 2.000000)"
                                stroke="#585858"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path
                                    d="M0,0 L4,0 L6.68,13.3896681 C6.86873697,14.3398761 7.71138394,15.0181901 8.68,14.9996282 L18.4,14.9996282 C19.3686161,15.0181901 20.211263,14.3398761 20.4,13.3896681 L22,4.99987606"
                                    strokeWidth="2"
                                ></path>
                                <line x1="9.5" y1="11" x2="17.5" y2="11" id="Path-2" strokeWidth="2"></line>
                                <line x1="9.5" y1="7" x2="17.5" y2="7" id="Path-2-Copy" strokeWidth="2"></line>
                                <line x1="9.5" y1="3" x2="17.5" y2="3" id="Path-2-Copy-2" strokeWidth="2"></line>
                                <line x1="18.49625" y1="19.5" x2="18.50375" y2="19.5" id="Path" strokeWidth="3"></line>
                                <line x1="7.49625" y1="19.5" x2="7.50375" y2="19.5" id="Path" strokeWidth="3"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default ShoppingCart;
